import React, { useEffect } from "react";
import {
  Flex,
  Input,
  Loader,
  ScrollArea,
  Table,
  Text,
  createStyles,
} from "@mantine/core";
import { useState } from "react";
import { useSelector } from "react-redux";
import { NoteTableRowDashboard } from "../NoteTableRow";
import TableLoader from "../TableLoader";
import NoteModalNew from "../NoteModal/NoteModalNew";
import { IconSearch } from "@tabler/icons-react";
import { getTodaysNotes } from "../../services/dashboard";
import useDebounce from "../../utils/useDebounce";

const useStyles = createStyles((theme) => ({
  header: {
    position: "sticky",
    top: 0,
    "& th": {
      backgroundColor: "var(--app-surface)",
      color: "var(--app-text) !important",
    },

    transition: "box-shadow 150ms ease",
  },

  scrolled: {
    // boxShadow: theme.shadows.sm,
  },
  notFoundTextContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "460px",
    width: "100%",
  },
  searchInput: {
    width: "45%",
    marginBlock: "10px",
    borderRadius: "10px",
    "& :focus-within": {
      border: "1px solid var(--app-border)",
    },
    "& :focus": {
      border: "1px solid var(--app-border)",
    },
    "& :hover": {
      border: "1px solid var(--app-border)",
    },
    "& :active": {
      border: "1px solid var(--app-border)",
    },
    "& :focus-visible": {
      border: "1px solid var(--app-border)",
    },
  },
}));

export function DashTable() {
  const { notes, loading } = useSelector((state) => state?.dashboard);
  // const { notes, loading } = useSelector((state) => state?.note);
  const { classes, cx } = useStyles();
  const [scrolled, setScrolled] = useState(false);
  const [isopen, setOpen] = useState(false);
  const [data, setData] = useState(null);
  const [noteType, setNoteType] = useState(null);
  const [view, setView] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  const debouncedSearch = useDebounce(searchTerm, 2000);

  useEffect(() => {
    if (debouncedSearch) {
      getTodaysNotes(debouncedSearch);
    } else {
      getTodaysNotes("");
    }
  }, [debouncedSearch, getTodaysNotes]);

  return (
    <ScrollArea
      h={460}
      onScrollPositionChange={({ y }) => setScrolled(y !== 0)}
    >
      {/* <NoteModal
        opened={isopen}
        close={() => {
          setOpen(false);
          setData(null);
        }}
        noteType={noteType}
        title={"Add New Note"}
        view={view}
        setView={setView}
        data={data}
      /> */}

      <NoteModalNew
        opened={isopen}
        close={() => {
          setOpen(false);
          setData(null);
        }}
        noteType={noteType}
        title={"Add New Note"}
        view={view}
        setView={setView}
        data={data}
      />

      <div style={{ overflowX: "auto" }}>
        <div style={{ minWidth: "600px" }}>
          {notes?.length > 0 && (
            <Input
              icon={<IconSearch />}
              placeholder="Search"
              className={classes.searchInput}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          )}
          {loading ? (
            <Flex align="center" justify="center" h={460}>
              <Loader color="var(--app-primary)" />
            </Flex>
          ) : notes?.length === 0 ? (
            <div className={classes.notFoundTextContainer}>
              <p className={classes.notFoundText}>
                You don&apos;t have any record for Notes in last 24 hours
              </p>
            </div>
          ) : (
            <Table
              withBorder
              sx={{ fontFamily: "Inter" }}
              fontSize={"sm"}
              verticalSpacing={"md"}
            >
              <thead
                className={cx(classes.header, { [classes.scrolled]: scrolled })}
              >
                <tr>
                  <th style={{ minWidth: "140px" }}>Note Type</th>
                  <th style={{ minWidth: "140px" }}>Staff Name</th>
                  <th style={{ minWidth: "140px" }}>Client Name</th>
                  <th style={{ minWidth: "140px" }}>Facility Name</th>
                  <th style={{ minWidth: "140px" }}>Date</th>
                  <th style={{ minWidth: "140px" }}>Time</th>
                  <th style={{ minWidth: "140px" }}>Description</th>
                  <th style={{ minWidth: "140px" }}>Action</th>
                </tr>
              </thead>
              <tbody>
                {notes?.map((row, i) => (
                  <NoteTableRowDashboard
                    row={row}
                    key={i}
                    index={i}
                    open={(data) => {
                      setData(data);
                      setOpen(true);
                    }}
                    setView={() => {
                      setView(true);
                    }}
                  />
                ))}
              </tbody>
            </Table>
          )}
        </div>
      </div>
    </ScrollArea>
  );
}
